<template>
  <GeoVerification
    :action-label="t(useTranslationPath(callerPath, 'continue'))"
    :verification-method="useGetConfigVar('ENGINEER_APP_CHECK_OUT_METHOD')"
    :is-loading
    @continue="handleCheckOut"
    @access-code="handleAccessCode"
  />
</template>

<script setup>
import GeoVerification from '@/components/Verification/GeoVerification.vue'
import { useGetConfigVar } from '@/composables/useGetConfigVar.js'
import { useGoBack } from '@/composables/useGoBack.js'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { isLocationEnabled } from '@/composables/useVerificationMethod.js'
import { useAppStore } from '@/stores/AppStore.js'
import { useEngineerStore } from '@/stores/authenticated/EngineerStore.js'
import { useWorkOrderStore } from '@/stores/authenticated/WorkOrderStore.js'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const { setCustomGoBack } = useGoBack()

const callerPath = 'views.authenticated.workOrders.checkout.verification.geo'

const appStore = useAppStore()
const engineerStore = useEngineerStore()
const workOrderStore = useWorkOrderStore()

const isLoading = ref(false)

onMounted(() => {
  setCustomGoBack(() =>
    router.push({
      name: `work-order.detail`,
      params: {
        workOrderId: workOrderStore.workOrder.id,
      },
    }),
  )

  engineerStore.$patch({
    verificationData: {
      checkIn: engineerStore.verificationData.checkIn,
      checkOut: { method: null, data: null },
    },
  })

  appStore.$patch({ showBackButton: true })
})

const handleCheckOut = async (verified = true, coordinates = null) => {
  isLoading.value = true

  if (isLocationEnabled('ENGINEER_APP_CHECK_OUT_METHOD') && verified) {
    engineerStore.$patch({
      verificationData: {
        checkIn: engineerStore.verificationData.checkIn,
        checkOut: {
          method: 'GEOLOCATION',
          data: { lat: coordinates[0], lng: coordinates[1] },
        },
      },
    })
  }

  await router.push({
    name: 'work-order.checkout.index',
    params: { workOrderId: route.params.workOrderId },
  })
}

const handleAccessCode = async () => {
  isLoading.value = true

  await router.push({
    name: 'work-order.checkout.verification.code',
    params: { workOrderId: route.params.workOrderId },
  })
}
</script>
